import FaceIcon from '@material-ui/icons/Business';
import TenantGroupsList from './TenantGroupsList';
import TenantGroupEdit from './TenantGroupEdit';

export default {
    list: TenantGroupsList,
    edit: TenantGroupEdit,
    icon: FaceIcon,
};